import { Box, Typography } from "@mui/material";

export default function DataGridCustomNoRowsOverlay(props) {
	const message = props.message || "No results.";
	return (
		<Box sx={{ backgroundColor: "#3551A414", borderRadius: "25px", minHeight: "500px"}}>
			<Typography sx={{fontSize: "25px", margin: 0, padding: "50px", textAlign: "center"}}>{ message }</Typography>
		</Box>
	); 
}